// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';
import CalendarView from '@/views/CalendarView.vue';
import LoginView from '@/views/LoginView.vue';
import RegisterView from '@/views/RegisterView.vue';
import DetailView from '@/views/DetailView.vue';
import NoPermission from '@/views/NoPermission.vue';
import { useAuthStore } from '../stores/useAuthStore';
import { useMainStore } from '../stores/useMainStore';


const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView,
    meta: { requiresGuest: true }
  },
  {
    path: '/feed',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: CalendarView,
    meta: { requiresAuth: true }
  },
  {
    path: '/campaign-planner',
    name: 'CampaignPlanner',
    component: () => import('@/views/CampaignPlannerView.vue'),
    meta: { requiresAuth: true }
  },
  // New Insights Promo route
  {
    path: '/insights/promo',
    name: 'InsightsPromo',
    component: () => import('@/views/InsightsPromo.vue'),
    meta: { requiresAuth: true }
  },
  // New Insights Email route
  {
    path: '/insights/email',
    name: 'InsightsEmail',
    component: () => import('@/views/InsightsEmail.vue'),
    meta: { requiresAuth: true }
  },
  // Optionally redirect /insights to /insights/promo
  {
    path: '/insights',
    redirect: '/insights/promo'
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { requiresGuest: true }
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: NoPermission
  },
  {
    path: '/details/:id',
    name: 'DetailView',
    component: DetailView,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const mainStore = useMainStore();        // <- NEU

  // 1) User aus der Session holen, falls noch nicht im Store
  if (!authStore.user) {
   await authStore.fetchUser();
   }
  
   // 2) Daten nur ein einziges Mal laden
   if (authStore.user && !mainStore._hasBootstrapped) {
     await mainStore.reloadData();
     mainStore._hasBootstrapped = true;   // Flag setzen
   }
  
  if (authStore.user && to.meta.requiresGuest) {
    next('/feed');
  } else if (to.meta.requiresAuth && !authStore.user) {
    next('/no-permission');
  } else {
    next();
  }
});

export default router;
